import { EvoPlayer } from '../views/GameVideo/EvoPlayer/player';

/**
 * @param {string} partialIdSelector Partial selector for the element
 * @returns {HTMLVideoElement}
 */
export function getNanoVideoElement(partialIdSelector = 'video-container'): HTMLElement | null | undefined {
  const videoSelector = `video[id*=${partialIdSelector}]`;
  const sourceSelector = `${videoSelector} source`;

  // Get video element from current frame
  const videoElement: HTMLVideoElement | null = document.querySelector(videoSelector);
  if (videoElement) return videoElement;

  // There are multiple iframes, each with a different video element
  const iframes: HTMLIFrameElement[] = Array.from(
    document.querySelectorAll('iframe[name*="h5live"]')
  );

  // We search for the current video using the src attribute of the source element
  const iframe = iframes.find((_iframe) => {
    const sourceElement = _iframe.contentWindow?.document.querySelector(sourceSelector);

    return sourceElement && sourceElement.getAttribute('src') !== '';
  });

  // Get video element from nano iframe (should happen only on iOS)
  return iframe ? iframe.contentWindow?.document.querySelector(videoSelector) : null;
}

const getActiveEvoVideoElement = (videoSelector: string) => {
  if (!EvoPlayer.initialized) return null;

  const videoElement: HTMLVideoElement | HTMLCanvasElement = EvoPlayer.container.get().querySelector(videoSelector)!;
  if (videoElement && videoElement.style.display !== 'none') {
    return videoElement;
  }

  return null;
};

/**
 * Based on factors like internet speed or device performance, the video element may be hidden
 * and a canvas element (used as a low-power alternative) is displayed instead, or the reverse may occur.
 * @returns {HTMLVideoElement}
 */
function getEvoVideoElement() {
  return getActiveEvoVideoElement('video') || getActiveEvoVideoElement('canvas');
}

/**
 * @returns {HTMLVideoElement}
 */
export function getVideoElement() {
  if (EvoPlayer.initialized) {
    return getEvoVideoElement();
  }

  return getNanoVideoElement();
}
